import { Backspace } from '@phosphor-icons/react';

export default Backspace;
